/* One centred column, as wide as an entity page's content column */
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(var(--tuna-spacing) * 2);
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: calc(var(--tuna-spacing) * 6) calc(var(--tuna-spacing) * 2);
  text-align: center;
}

.avatar {
  flex-shrink: 0;
}

.name {
  margin: 0;
  overflow-wrap: anywhere;
}

.email {
  margin: 0;
  color: var(--tuna-content-secondary);
  overflow-wrap: anywhere;
}

.link {
  color: var(--tuna-palette-primary-main);
  text-decoration: underline;
}

.edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Phones: a smaller avatar, and "Edit profile" becomes a full-width 44px button */
@media (max-width: 599.95px) {
  .root {
    padding-top: calc(var(--tuna-spacing) * 4);
  }

  .edit {
    width: 100%;
    min-height: 44px;
    border: 1px solid var(--tuna-brand-border);
    border-radius: var(--tuna-shape-radius-md);
  }
}
